export default "__VITE_ASSET__BI7HOz3G__"